export const inputClassList = {
  computed: {
    inputClasses() {
      let classList = ''

      classList += this.isRecommendedField && (this.value === null || this.value.length === 0) ? 'nhbr-recommended ' : ' '
      classList += this.isValidField ? ' ' : 'nhbr-invalid'

      return classList
    }
  }
}